// The public header's links and where a public page scrolls after a navigation
// (TOM-980). Plain functions, so the rules run under node with no DOM.

export interface SiteNavLink {
  to: string;
  label: string;
}

/** The header's page links, in order. Sign in and Join the beta follow them. */
export const SITE_NAV: readonly SiteNavLink[] = [
  { to: '/#neo', label: 'Meet Neo' },
  { to: '/#how', label: 'How it works' },
  { to: '/contact', label: 'Contact' },
];

/** Join the beta goes to the home page's form on "/" and to /beta on every other page. */
export function joinBetaHref(pathname: string): string {
  return pathname === '/' ? '#beta' : '/beta';
}

/** The element id a location hash names, or null for no hash. */
export function hashId(hash: string): string | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (raw === '') return null;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export interface Place {
  pathname: string;
  search: string;
  hash: string;
}

export type ScrollTarget = { kind: 'element'; id: string } | { kind: 'top' } | { kind: 'none' };

/**
 * Where to scroll after the location changes from `prev` to `next`. A hash
 * scrolls to its element. A new page, a removed hash, or a link to the page
 * already open scrolls to the top. A change to the query alone leaves the
 * scroll where it is.
 */
export function scrollTargetFor(prev: Place | null, next: Place): ScrollTarget {
  const id = hashId(next.hash);
  if (id !== null) return { kind: 'element', id };
  if (prev === null || prev.pathname !== next.pathname) return { kind: 'top' };
  if (prev.search !== next.search) return { kind: 'none' };
  return { kind: 'top' };
}
